import { useCallback } from 'react';
import { AxiosResponse } from 'axios';
import { IActionButtonsDisplayConfig } from '../components/customiseContainer/actionButtons/ActionButtonsContainer';
import { useRequestUrl } from './useRequestUrl';
import { useBasketInitV3 } from './useBasketInitV3';
import { JourneyType } from '../../__generated__/globalTypes';
import basketApi from '../api/basketApi';
import urlMinify from '../../common/utils/urlMinify';
import errorHandler from '../../gqlCommon/service/errorHandler';
import IDeal from '../../common/model/IDeal';
import CheckoutDataLayer from '../../common/utils/dataLayer/graphql/checkoutDataLayer';
import useWidgetContext from '../../common/react/useWidgetContext';

const useCheckoutRedirectHandler = (config: IActionButtonsDisplayConfig, journeyType?: JourneyType) => {
  if (!journeyType) {
    journeyType = config.configurator.defaultCheckoutJourney;
  }
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const { getRequestQuoteUrl } = useRequestUrl();
  const { getBasketInitV3Data } = useBasketInitV3(journeyType);
  const basketInitV3Data = getBasketInitV3Data();

  const checkoutRedirectHandler = useCallback(
    async (onLoadCallback: (isLoading: boolean) => void) => {
      onLoadCallback(true);

      if (config.isCheckoutLiteEnabled && basketInitV3Data) {
        if (config.isCheckout3Enabled || config.isCheckout4Enabled) {
          try {
            const { dealId, url } = await getRequestQuoteUrl(config, journeyType);
            CheckoutDataLayer(dimensions, dealId);
            (window as any).location = url;
          } catch (error) {
            errorHandler.handleError(error);
          } finally {
            onLoadCallback(false);
          }
        } else if (config.requestQuoteUrl) {
          const minifiedConfigurationUrl = await urlMinify.shorten(basketInitV3Data.configurationSourceUrl);

          const updatedBasketInitV3Data = {
            ...basketInitV3Data,
            configurationSourceUrl: minifiedConfigurationUrl,
          };

          try {
            const response: AxiosResponse<IDeal> = await basketApi.preInitBasketComplex(updatedBasketInitV3Data);
            if (response) {
              window.location.href = config.requestQuoteUrl;
            }
          } catch (error) {
            errorHandler.handleError(error);
          } finally {
            onLoadCallback(false);
          }
        }
      }
    },
    [config, journeyType, getRequestQuoteUrl],
  );

  return {
    checkoutRedirectHandler,
    basketInitV3Data,
  };
};

export default useCheckoutRedirectHandler;
